function link(name, url) {
  return `<a href='${url}' rel='noopener noreferrer' target='_blank'>${name}</a>`;
}

const config = {
  api_url: 'https://api.smartagro.lv/meteo',
  basemap_url: 'https://api.mapbox.com/styles/v1/{tileid}/tiles/{z}/{x}/{y}?access_token={token}',
  basemap_token: 'pk.eyJ1IjoicmVjb241MTciLCJhIjoiY2l4cXBpbzZtMDAzNDMybDY2YnAzdjlndSJ9.MRq_ohDyD2x5t5DdlAwytA',
  basemap_attrib: `&copy; ${link('Mapbox','https://www.mapbox.com/about/maps/')} &copy; ${link('OpenStreetMap','https://www.openstreetmap.org/copyright')} <strong>${link('Improve this map','https://www.mapbox.com/map-feedback/')}</strong>`,
  update_frequency: 15 * 60, //in seconds
  config_widgets: {
    location: {
      caption: 'Vietas izvēle',
      default: {
        'Rīga': {
          coords: [56.95, 24.10],
          id: '2410-5695',
          name: 'Rīga',
          visible: true,
        },
      },
      togglable: false,
    },
    provider: {
      caption: 'Meteo datu avots',
      default: {
        'LVĢMc': {
          id: 'meteo-lv',
          visible: true,
          name: 'LVĢMc',
        },
        'MET Norway': {
          id: 'met-no',
          visible: true,
          name: 'MET Norway',
        },
      },
      togglable: false,
    },
    time: {
      caption: 'Laiks',
      default: {
        '000': {
          id: '000',
          name: 'Tagad',
          visible: true,
        },
        '002': {
          id: '002',
          name: 'Pēc divām stundām',
          visible: true,
        },
        '004': {
          id: '004',
          name: 'Pēc četrām stundām',
          visible: true,
        },
        '024': {
          id: '024',
          name: 'Pēc 24 stundām',
          visible: true,
        },
      },
      togglable: false,
    },
    param: {
      caption: 'Rādītājs',
      default: {
        'Gaisa spiediens (jūras līmenī)': {id: 'air_pressure_at_sea_level', name: 'Gaisa spiediens (jūras līmenī)', visible: false},
        'Gaisa temperatūra (10th percentile)': {id: 'air_temperature_percentile_10', name: 'Gaisa temperatūra (10th percentile)', visible: false},
        'Gaisa temperatūra (90th percentile)': {id: 'air_temperature_percentile_90', name: 'Gaisa temperatūra (90th percentile)', visible: false},
        'Gaisa temperatūra (maksimālā)': {id: 'air_temperature_max', name: 'Gaisa temperatūra (maksimālā)', visible: false},
        'Gaisa temperatūra (minimālā)': {id: 'air_temperature_min', name: 'Gaisa temperatūra (minimālā)', visible: false},
        'Gaisa temperatūra': {id: 'air_temperature', name: 'Gaisa temperatūra', visible: true},
        'Mākoņu daudzums': {id: 'cloud_area_fraction', name: 'Mākoņu daudzums', visible: false},
        'Nokrišņu daudzums (maksimālais)': {id: 'precipitation_amount_max', name: 'Nokrišņu daudzums (maksimālais)', visible: false},
        'Nokrišņu daudzums (minimālais)': {id: 'precipitation_amount_min', name: 'Nokrišņu daudzums (minimālais)', visible: false},
        'Nokrišņu daudzums': {id: 'precipitation_amount', name: 'Nokrišņu daudzums', visible: true},
        'Nokrišņu varbūtība': {id: 'probability_of_precipitation', name: 'Nokrišņu varbūtība', visible: false},
        'Rasas punkts': {id: 'dew_point_temperature', name: 'Rasas punkts', visible: false},
        'Relatīvais mitrums': {id: 'relative_humidity', name: 'Relatīvais mitrums', visible: false},
        'Vēja brāzmu ātrums': {id: 'wind_speed_of_gust', name: 'Vēja brāzmu ātrums', visible: false},
        'Vēja virziens': {id: 'wind_from_direction', name: 'Vēja virziens', visible: false},
        'Vēja ātrums (10th percentile)': {id: 'wind_speed_percentile_10', name: 'Vēja ātrums (10th percentile)', visible: false},
        'Vēja ātrums (90th percentile)': {id: 'wind_speed_percentile_90', name: 'Vēja ātrums (90th percentile)', visible: false},
        'Vēja ātrums': {id: 'wind_speed', name: 'Vēja ātrums', visible: true},
        // 'Laika apstākļu simbols': {id: 'symbol_code', name: 'Laika apstākļu simbols', visible: false},
        // 'Mākoņu daudzums (high)': {id: 'cloud_area_fraction_high', name: 'Mākoņu daudzums (high)', visible: false},
        // 'Mākoņu daudzums (low)': {id: 'cloud_area_fraction_low', name: 'Mākoņu daudzums (low)', visible: false},
        // 'Mākoņu daudzums (medium)': {id: 'cloud_area_fraction_medium', name: 'Mākoņu daudzums (medium)', visible: false},
      },
      togglable: false,
    },
    layout: {
      caption: 'Izkārtojums',
      default: {
        choices: {
          'Vieta, Rādītājs, Datu avots, Laiks': {id: 'location-param-provider-time', name: 'Vieta, Rādītājs, Datu avots, Laiks'},
          'Vieta, Rādītājs, Laiks, Datu avots': {id: 'location-param-time-provider', name: 'Vieta, Rādītājs, Laiks, Datu avots'},
          'Vieta, Datu avots, Rādītājs, Laiks': {id: 'location-provider-param-time', name: 'Vieta, Datu avots, Rādītājs, Laiks'},
          'Vieta, Datu avots, Laiks, Rādītājs': {id: 'location-provider-time-param', name: 'Vieta, Datu avots, Laiks, Rādītājs'},
          'Vieta, Laiks, Rādītājs, Datu avots': {id: 'location-time-param-provider', name: 'Vieta, Laiks, Rādītājs, Datu avots'},
          'Vieta, Laiks, Datu avots, Rādītājs': {id: 'location-time-provider-param', name: 'Vieta, Laiks, Datu avots, Rādītājs'},
          'Rādītājs, Vieta, Datu avots, Laiks': {id: 'param-location-provider-time', name: 'Rādītājs, Vieta, Datu avots, Laiks'},
          'Rādītājs, Vieta, Laiks, Datu avots': {id: 'param-location-time-provider', name: 'Rādītājs, Vieta, Laiks, Datu avots'},
          'Rādītājs, Datu avots, Vieta, Laiks': {id: 'param-provider-location-time', name: 'Rādītājs, Datu avots, Vieta, Laiks'},
          'Rādītājs, Datu avots, Laiks, Vieta': {id: 'param-provider-time-location', name: 'Rādītājs, Datu avots, Laiks, Vieta'},
          'Rādītājs, Laiks, Vieta, Datu avots': {id: 'param-time-location-provider', name: 'Rādītājs, Laiks, Vieta, Datu avots'},
          'Rādītājs, Laiks, Datu avots, Vieta': {id: 'param-time-provider-location', name: 'Rādītājs, Laiks, Datu avots, Vieta'},
          'Datu avots, Vieta, Rādītājs, Laiks': {id: 'provider-location-param-time', name: 'Datu avots, Vieta, Rādītājs, Laiks'},
          'Datu avots, Vieta, Laiks, Rādītājs': {id: 'provider-location-time-param', name: 'Datu avots, Vieta, Laiks, Rādītājs'},
          'Datu avots, Rādītājs, Vieta, Laiks': {id: 'provider-param-location-time', name: 'Datu avots, Rādītājs, Vieta, Laiks'},
          'Datu avots, Rādītājs, Laiks, Vieta': {id: 'provider-param-time-location', name: 'Datu avots, Rādītājs, Laiks, Vieta'},
          'Datu avots, Laiks, Vieta, Rādītājs': {id: 'provider-time-location-param', name: 'Datu avots, Laiks, Vieta, Rādītājs'},
          'Datu avots, Laiks, Rādītājs, Vieta': {id: 'provider-time-param-location', name: 'Datu avots, Laiks, Rādītājs, Vieta'},
          'Laiks, Vieta, Rādītājs, Datu avots': {id: 'time-location-param-provider', name: 'Laiks, Vieta, Rādītājs, Datu avots'},
          'Laiks, Vieta, Datu avots, Rādītājs': {id: 'time-location-provider-param', name: 'Laiks, Vieta, Datu avots, Rādītājs'},
          'Laiks, Rādītājs, Vieta, Datu avots': {id: 'time-param-location-provider', name: 'Laiks, Rādītājs, Vieta, Datu avots'},
          'Laiks, Rādītājs, Datu avots, Vieta': {id: 'time-param-provider-location', name: 'Laiks, Rādītājs, Datu avots, Vieta'},
          'Laiks, Datu avots, Vieta, Rādītājs': {id: 'time-provider-location-param', name: 'Laiks, Datu avots, Vieta, Rādītājs'},
          'Laiks, Datu avots, Rādītājs, Vieta': {id: 'time-provider-param-location', name: 'Laiks, Datu avots, Rādītājs, Vieta'},
        },
        chosen: 'Vieta, Rādītājs, Datu avots, Laiks',
      },
      togglable: false,
    },
  },
  units: {
    celsius: '°C',
    degrees: '°'
  }
};
export default config;
